
export class CheckboxGroup {
  public static wireup() {
    let headerIsBeingUpdatedFromHeaderChange = {};
    let headerIsBeingUpdatedFromItemChange = {};

    let updateGroupHeader = function (key: string): void {
      if (headerIsBeingUpdatedFromHeaderChange[key])
        return;

      let header = document.querySelector('checkbox-group-header'.asDataSelector(key)) as HTMLInputElement;
      let checkboxes = document.querySelectorAll('checkbox-group-item'.asDataSelector(key));

      let allCheckboxesAreChecked = true;
      for (let i = 0; i < checkboxes.length; i++) {
        if (!(<HTMLInputElement>checkboxes.item(i)).checked) {
          allCheckboxesAreChecked = false;
          break;
        }
      }
      if (header.checked !== allCheckboxesAreChecked) {
        header.checked = allCheckboxesAreChecked;
        try {
          headerIsBeingUpdatedFromItemChange[key] = true;
          header.trigger('change');
        }
        finally {
          headerIsBeingUpdatedFromItemChange[key] = false;
        }
      }
    };

    $(document).on('checkboxgroupchanged', '[data-checkbox-group-header]', function (e: Event) {
      let header = e.target as HTMLInputElement;
      updateGroupHeader(header.getAttribute('data-checkbox-group-header'));
    });

    $(document).on('click', '[data-checkbox-group-item-row]', function (e: JQueryEventObject) {
      let target = e.target as HTMLElement;
      var textIsHighlighted = getSelection().toString();
      if (target.matches("a") || target.matches("input") || textIsHighlighted)
        return;

      let item = target.closest('[data-checkbox-group-item-row]').querySelector('[data-checkbox-group-item]') as HTMLInputElement;
      if (e.ctrlKey) {
        item.checked = !item.checked;
        item.trigger('change');
        return;
      }

      let wasChecked = item.checked;
      let key = item.getAttribute('data-checkbox-group-item');
      let checkboxes = document.querySelectorAll('checkbox-group-item'.asDataSelector(key));
      Array.prototype.slice.call(checkboxes).forEach(function (checkbox: HTMLInputElement) {
        let shouldTriggerChangeEvent = checkbox.checked == true;
        checkbox.checked = false;
        if (shouldTriggerChangeEvent)
          checkbox.trigger('change');
      });

      if (wasChecked)
        return;
      item.checked = true;
      item.trigger('change');
    });

    $(document).on('change rustig.valuebinding.valueset', '[data-checkbox-group-header]', function (e: Event) {
      let header = e.target as HTMLInputElement;
      let key = header.getAttribute('data-checkbox-group-header');

      if (headerIsBeingUpdatedFromItemChange[key])
        return;

      try {
        headerIsBeingUpdatedFromHeaderChange[key] = true;
        let checkboxes = document.querySelectorAll('checkbox-group-item'.asDataSelector(key));
        Array.prototype.slice.call(checkboxes).forEach(function (checkbox: HTMLInputElement) {
          let isChecked = checkbox.checked;
          checkbox.checked = header.checked;
          if (isChecked !== checkbox.checked)
            checkbox.trigger('change');
        });
      }
      finally {
        headerIsBeingUpdatedFromHeaderChange[key] = false;
      }
    });

    let shouldHighlightSelectedRows = function(checkbox: HTMLInputElement): boolean {
      return checkbox.closest('.checkbox-group-multiselect') != null;
    }

    $(document).on('change rustig.valuebinding.valueset', '[data-checkbox-group-item]', function (e: Event) {
      let target = e.target as HTMLInputElement;
      let key = target.getAttribute('data-checkbox-group-item');
      updateGroupHeader(key);

      if (shouldHighlightSelectedRows(target)) {
        let tableRow = target.closest('tr');
        if (tableRow != null && tableRow.closest('thead') == null) {
          if ((<HTMLInputElement>target).checked)
            tableRow.classList.add('selected');
          else
            tableRow.classList.remove('selected');
        }
      }
    });
  }
}